import React from 'react';
import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';
import {QueryClient, QueryClientProvider} from 'react-query';
import {BrowserRouter as Router} from 'react-router-dom';
import {QueryParamProvider} from 'use-query-params';
import {ReactRouter6Adapter} from 'use-query-params/adapters/react-router-6';

import './index.css';
import Analytics from './components/Analytics';
import {AuthProvider} from './components/Auth';
import H5PreviewToggle from './components/H5PreviewToggle';
import LoadingSpinner from './components/LoadingSpinner';
import {SentrySessionReplayListener, SentryUserListener, initSentry} from './components/Sentry';
import {TranslationsProvider} from './components/TranslationsContext';
import FirebaseProvider, {initializeFirebase} from './components/Utility/Firebase';
import VersionUpdateMonitor from './components/Utility/VersionUpdateMonitor';
import {initBeacon} from './lib/beacon';
import HelpScout from './lib/helpscout';
import {initHubspot} from './lib/hubspot';
import Routes from './Routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

initBeacon();
initHubspot();
initializeFirebase();
initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <AuthProvider
            renderLoading={() => (
              <div className="min-h-screen flex justify-center items-center">
                <LoadingSpinner />
              </div>
            )}
          >
            <FirebaseProvider>
              <VersionUpdateMonitor>
                <SentrySessionReplayListener />
                <SentryUserListener />
                <HelpScout />
                <Analytics />
                <TranslationsProvider>
                  <H5PreviewToggle />
                  <Routes />
                </TranslationsProvider>
              </VersionUpdateMonitor>
            </FirebaseProvider>
          </AuthProvider>
        </QueryParamProvider>
      </Router>
    </QueryClientProvider>
  </React.StrictMode>
);
